export class CollectionSubscriptionCanceled extends Error {}
